<template>
  <v-container :fluid="$vuetify.breakpoint.width < 1050 ? true : false">
    <v-row>
      <v-col>
        <v-carousel v-if="!$vuetify.breakpoint.smAndDown" hide-delimiters :cycle="isCyclying" continuous height="300">

          <template v-slot:next="{ attrs, on }">
            <v-btn icon v-bind="attrs" v-on="on" @click="stopCycle">
              <feather type="chevron-right" />
            </v-btn>
          </template>
          <template v-slot:prev="{ attrs, on }">
            <v-btn icon v-bind="attrs" v-on="on" @click="stopCycle">
              <feather type="chevron-left" />
            </v-btn>
          </template>


          <v-carousel-item eager transition="slide-x-transition" v-for="(items, i) in chunkItems" :key="i">
            <v-row>
              <v-col v-for="item in items" :key="item.title">
                <v-card class="pa-5 card" height="300" flat style="border-radius: 10px;">
                  <p class="par">
                    {{ item.readmore ? getDescription(item.description) : item.description }}

                    <v-dialog v-model="item.dialog" width="500"
                      v-if="item.readmore && isLongDescription(item.description)">
                      <template v-slot:activator="{ on, attrs }">
                        <span class="primary--text" dark v-bind="attrs" v-on="on" @click="stopCycle">
                          ...read more
                        </span>
                      </template>
                      <v-card>
                        <v-card-title class="text-h5 secondary headers2">
                          <h2 class="headers2"> {{ item.title }} </h2>
                        </v-card-title>
                        <v-card-text class="par py-4">
                          {{ item.description }}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" class="par" text @click="item.dialog = false">
                            Close
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </p>
                  <h2 class="headers2"> {{ item.title }} </h2>
                  <br />
                  <v-img width="100" src="@/assets/5 stars.png" />
                </v-card>
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>
        <v-carousel v-else hide-delimiters :cycle="isCyclying" continuous height="">

          <template v-slot:next="{ attrs, on }">
            <v-btn class="btn-icon" icon v-bind="attrs" v-on="on" @click="stopCycle">
              <feather type="chevron-right" />
            </v-btn>
          </template>
          <template v-slot:prev="{ attrs, on }">
            <v-btn class="btn-icon" icon v-bind="attrs" v-on="on" @click="stopCycle">
              <feather type="chevron-left" />
            </v-btn>
          </template>

          <v-carousel-item eager transition="slide-x-transition" v-for="(item, i) in items" :key="i">
            <v-row>
              <v-col>
                <v-card class="pa-5 card" flat style="border-radius: 10px;">
                  <p class="par">
                    {{ item.description }}
                  </p>
                  <h2 class="headers2"> {{ item.title }} </h2>
                  <br />
                  <v-img width="100" src="@/assets/5 stars.png" />
                </v-card>
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "WhatClientThink",
  data() {
    return {
      isCyclying: true,
      dialog: false,
      items: [
        {
          description: "Super swift service and great communication throughout.",
          title: "Kate Mason - Oct 2026",
        },
        {
          description: "Dash Waste provides fast, friendly and reliable service. Zahid is always helpful, patient and willing to assist, even with last-minute requests and tight deadlines.",
          title: "Casa Viglietti - Aug 2026",
          readmore: true
        },
        {
          description: "The guys as Dash Waste are true life savers! As a woman going through a divorce, they have gone way beyond to make sure I was covered and had zero stress with clearing out my household clutter. I highly, highly recommend them. Exceptional customer service. 5 stars!",
          title: "M. Matthaei - July 2026",
          readmore: true
        },
        {
          description: "Thanks for on-time delivery, good comms and a clear and easy payment process. Please find proof of payment attached.",
          title: "Karin Hunter - July 2026"
        },
        {
          description: "As a theatre, we always have unusual debris and rubbish collecting as a result of various shows building their different stage sets. We've used Dash Waste several times over the past year and couldn't be happier with their service. The website booking system works smoothly, their communication is excellent and their service is always friendly & reliable.",
          title: "The Playhouse Theatre - May 2026",
          readmore: true
        },
        {
          description: "Dash Waste…… if I hear that name, the following words come into my mind: professional, friendly, helpful, responsible and reliable. Would not want it any other way! Thank you.",
          title: "Karin Koep - May 2026",
          readmore: true
        },
        {
          description: "Absolute life savers! Thank you Zahid for a seamless process and reducing all my rubble stress! Dash waste organized everything for me within a day even though I hardly gave them any lead time. An absolute pleasure to deal with and very friendly and efficient service as well. Pricing also very reasonable.",
          title: "Nazeck Booley - May 2026",
          readmore: true
        },
        {
          description: "Exceptional service and speed with the supply and removal of a skip. Keep up the great work.",
          title: "Gawie Rossouw - Sept 2025",
        },
        {
          description: "Dash Waste have been absolutely fantastic to work with! They’ve helped me out on multiple occasions with short-notice collections and always deliver on time. The team is professional, friendly, and really go the extra mile to make things easy and hassle-free. Reliable service like this is hard to find these days – I’d highly recommend Dash Waste to anyone looking for efficient and trustworthy waste removal.",
          title: "MCT Telecommunications - Aug 2025",
          readmore: true
        },
        {
          description: "We are a small company & if we use 20 bins a year,it's a lot. But the friendly, excellent service that I always get is amazing! It is really top class! Zahid will always go out of his way to get the bin to our sites asap. The drivers are just as good. So thank you very much for your 5 star service. It just makes my life & job a lot easier.",
          title: "Godfrey - Just Damp - Aug 2025",
          readmore: true
        },
        {
          description: 'Been using them in Cape Town and now Jhb for my projects. Fastest and best with top notch support catering to all my requests',
          title: 'ACB Projects - April 2025',
          readmore: true
        },
        {
          description: 'Thank you for your professional service. I will be using your company going forward.',
          title: 'Everlasting Maintenance Services - April 2025',
        },
        {
          description: 'Professional, friendly, efficient and always willing to assist! What a pleasure to deal with such a service orientated company.',
          title: 'Karen Koep - March 2025',
          readmore: true
        },
        {
          description: 'Great service, efficiency, and genuine friendliness. If you’re looking for a waste management company that truly prioritizes customer satisfaction, I can highly recommend Dash Waste Skips. Their dedication and customer care make all the difference.',
          title: 'Burgers Equipment - March 2025',
          readmore: true
        },
        {
          description: 'Booked and speedy delivery. Excellent service. Money for time usage. The best, Thank you.',
          title: 'Bardine De Villiers - Jan 2025'
        },
        {
          description: 'Thank you for a very nice experience. Pleasure dealing with you.',
          title: 'Dennis Butlion - May 2024'
        },
      ],
    }
  },
  computed: {
    chunkItems() {
      let items = [];
      for (let i = 0; i < this.items.length; i += 3) {
        items.push(this.items.slice(i, i + 3));
      }

      return items;
    }
  },
  methods: {
    stopCycle() {
      this.isCyclying = false;
    },
    isLongDescription(text) {
      let words = text.split(" ");
      return words.length > 22;
    },
    getDescription(text) {
      let words = text.split(" ");
      return words.length > 22 ? words.slice(0, 22).join(" ") : text;
    }
  }

}
</script>
<style scoped>
div {
  font-family: AvenirMedium;
}

.headers2 {
  font-family: Avenir1;
  font-style: normal;
  font-weight: 750;
  font-size: 20px;
  line-height: 30px;
}

.par {
  font-family: Avenir3;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
}

.card {
  background-color: #00af6610;
}
</style>